import React from 'react'
import {
  connect,
  mapStateToProps,
  mapDispatchToProps,
  axiosCompany
} from '../helpers/Common'

class UpdateInfo extends React.Component {
  componentDidMount() {
    if (this.props.redux.setUpdateInfo) return true

    this.loadUpdateInfo()

    /**
     * ambil info secara berkala
     */
    const interval = setInterval(() => {
      this.loadUpdateInfo()
    }, 1000 * 60)

    this.props.setState({ setUpdateInfo: interval })
  }

  loadUpdateInfo() {
    axiosCompany().get('stats/update-info').then((result) => {
      let resData = result.data
      resData.over_limit = []

      Object.keys(resData).map((key, i) => {
        if (typeof resData[key] === 'string') {
          if (resData[key].includes('+')) {
            resData[key] = resData[key].replace('+', '')
            resData.over_limit.push(key)
          }
          resData[key] = Number(resData[key])
        }
      })
      this.props.setState({ notifications: resData })
    })
  }

  componentWillUnmount() {
    clearInterval(this.props.redux.setUpdateInfo)
  }

  render() {
    return <></>
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdateInfo)
